import style from "./ForgetPassword.module.css";
import Input from "../input/Input";
import Logo from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import validateInput from "../../utilities/validations/validateInput";
import { toast } from "react-toastify";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { forgetPasswordApi } from "../../stores/slices/updatePasswordSlice";
import { preAuth } from "../../stores/slices/preAuthSlice";
import Loader from "../menu/Loader";
import React, { useEffect } from "react";
import { language } from "../../stores/slices/languageSlice";
import { getRegistrationTokenPPP } from "../../utilities/API/supertokenServices";
import { PARTNER_AUTH, PARTNER_BROWSER_ID } from "../../constant/Constants";
import { sendPasswordResetEmail } from "supertokens-web-js/recipe/emailpassword";

const ResetPassword = () => {
  const selectedLanguage = useSelector(language).ForgetPassword;
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const preAuthdetail = useSelector((state) => state.preAuthSlice);
  const updatePasswordDetails = useSelector(
    (state) => state.updatePasswordSlice
  );
  const[loader,setLoader] = useState(false)
  const [resetPassword, setResetPassword] = useState({
    Email_Address: {
      value: "",
      isValid: true,
    },
  });
  const resetPasswordDetails = useSelector(
    (state) => state.updatePasswordSlice
  );
  const backtoLogin = () => {
    navigate("/");
  };
  const backtoRegister = () => {
    navigate("/register");
  };
  const resetpasswordOnchange = (e) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let fieldvalidation = e.target.getAttribute("fieldvalidation");
    let inputValidate = validateInput(inputValue, fieldvalidation);

    setResetPassword((prevState) => ({
      ...prevState,
      [name]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid,
      },
    }));
  };

  const resetpasswordFun = async() => {
    if (
      resetPassword.Email_Address.value != "" &&
      resetPassword.Email_Address.isValid
    ) {

          // dispatch(
          //   forgetPasswordApi({
          //     BrowserId: PARTNER_BROWSER_ID.ID,
          //     Email: resetPassword.Email_Address.value,
          //     authorization:PARTNER_AUTH.Authorization
          //   })
          // );
          try{
            setLoader(true)
            const resetEmail = await sendPasswordResetEmail({
              formFields: [{
                  id: "email",
                  value: resetPassword.Email_Address.value
              }]
          });
          if(resetEmail.status == "OK"){
            setLoader(false)
            navigate("/resetPasswordSuccess");
          }else{
            setLoader(false)
            toast.error(resetEmail.status);
          }
          }catch(err){
            setLoader(false)
            toast.error(selectedLanguage?.toastError);
          }
    } else {
      setLoader(false)
      setResetPassword((prevState) => ({
        ...prevState,
        Email_Address: {
          value: resetPassword.Email_Address.value,
          isValid: resetPassword.Email_Address.value != "" ? true : false,
        },
      }));
      toast.error(selectedLanguage?.toastError);
    }
  };
  // if (updatePasswordDetails?.passwordData?.passwordUpdateSccess) {
  //   navigate("/resetPasswordSuccess");
  // }
  useEffect(()=>{
    getRegistrationTokenPPP(registrationTokenResponse);
  },[])
const  registrationTokenResponse =()=>{
  if(PARTNER_AUTH == ''){
    toast.error("Error getting the OAuth details, Try after sometime!");
  }
}
  return (
    <>
      <div
        className={`${style.basic_container} d-flex justify-content-center `}
      >
        <div className={`${style.basic_page}`}>
          <div className=" d-flex justify-content-center pt-5">
            {" "}
            <img src={Logo} alt="logo" />
          </div>
          <h2 className={`pt-10 ${style.heder_title}`}>{selectedLanguage?.title}</h2>
          <p className="pt-3">
          {selectedLanguage?.content}
          </p>
          <div className="container d-flex justify-content-center ">
            <div className={`${style.input_fields}`}>
              <Input
                type="email"
                id="EmailAddress"
                name="Email_Address"
                label={selectedLanguage?.emailAddress}
                value={resetPassword.Email_Address.value}
                onChange={(e) => resetpasswordOnchange(e)}
                isValid={resetPassword.Email_Address.isValid}
                errorMsg={selectedLanguage?.errorMsg}
                fieldvalidation="email"
              />
            </div>
          </div>
          <div className="pt-5">
            <button
              onClick={resetpasswordFun}
              className={`btn ${style.buttons}`}
            >
              {selectedLanguage?.resetPassword}
            </button>
          </div>

          <div className="pb-5">
            <p onClick={backtoLogin} className={`pt-10  ${style.reg_link}`}>
              <u>{selectedLanguage?.backToLogin}</u>
            </p>{" "}
            &nbsp; &nbsp; &nbsp;
            <p onClick={backtoRegister} className={`pt-3  ${style.reg_link}`}>
              <u>{selectedLanguage?.backToRegister}</u>
            </p>
          </div>
        </div>
      </div>
      {resetPasswordDetails?.passwordData?.loader == true || loader ? <Loader /> : null}
    </>
  );
};

export default ResetPassword;
